export default "__VITE_ASSET__Bw34reEb__"